/**
 * Riga libera di un ordine: un prodotto non a catalogo, valido solo per
 * quell'ordine (nome, prezzo, IVA, quantita').
 *
 * order_items.product_id e' obbligatorio: come per le righe senza prodotto
 * dei negozi collegati, la riga punta al prodotto segnaposto dell'azienda
 * (slug 'flusia-riga-senza-prodotto', inattivo, senza giacenza, escluso dalla
 * sincronizzazione negozi) e porta line_type = 'custom'. Il nome mostrato e'
 * quello scritto sulla riga (product_name).
 */
import type { OrderItemInput } from '../types/orders';

/** Stesso slug usato da flusia-core (commerce_placeholder_product_id). */
export const CUSTOM_LINE_PRODUCT_SLUG = 'flusia-riga-senza-prodotto';
export const CUSTOM_LINE_PRODUCT_NAME = 'Riga senza prodotto';

export interface CustomOrderLineDraft {
  name: string;
  unitPrice: number;
  taxRate: number;
  quantity: number;
}

/** Messaggio d'errore in italiano, oppure null se la riga e' valida. */
export function validateCustomOrderLine(d: CustomOrderLineDraft): string | null {
  const name = d.name.trim();
  if (!name) return 'Scrivi il nome del prodotto';
  if (name.length > 255) return 'Nome troppo lungo (massimo 255 caratteri)';
  if (!Number.isFinite(d.quantity) || d.quantity <= 0) return 'La quantità deve essere maggiore di zero';
  if (!Number.isFinite(d.unitPrice) || d.unitPrice < 0) return 'Il prezzo non può essere negativo';
  if (!Number.isFinite(d.taxRate) || d.taxRate < 0 || d.taxRate > 100) return 'Aliquota IVA non valida';
  return null;
}

export function buildCustomOrderLine(d: CustomOrderLineDraft, placeholderProductId: string): OrderItemInput {
  return {
    product_id: placeholderProductId,
    product_name: d.name.trim(),
    quantity: d.quantity,
    unit_price: Math.round(d.unitPrice * 100) / 100,
    discount_amount: 0,
    tax_rate: d.taxRate,
    line_type: 'custom',
  };
}

export function isCustomOrderLine(item: { line_type?: string | null }): boolean {
  return item.line_type === 'custom';
}
